module.exports = __webpack_public_path__ + "static/4-7c046afbfccf94ff72b8ed43c9d5bf2f.jpg";